import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import GemCard from '../components/GemCard';
import { fetchGem, fetchGems, getImageUrl } from '../api';
import './GemDetail.css';

export default function GemDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [gem, setGem] = useState(null);
  const [related, setRelated] = useState([]);
  const [selectedImg, setSelectedImg] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchGem(id)
      .then(data => {
        setGem(data);
        setSelectedImg(0);
        setLoading(false);
        if (data.gemType) {
          fetchGems({ gemType: data.gemType })
            .then(rel => setRelated(rel.filter(g => g._id !== id).slice(0, 3)));
        }
      })
      .catch(() => setLoading(false));
  }, [id]);

  const allImages = gem ? [gem.image, ...(gem.images || []).filter(img => img !== gem.image)].filter(Boolean) : [];

  if (loading) {
    return (
      <div className="gemdetail-page">
        <Navbar />
        <div className="gemdetail-loading">
          <div className="gemdetail-skeleton-main" />
          <div className="gemdetail-skeleton-info" />
        </div>
        <Footer />
      </div>
    );
  }

  if (!gem) {
    return (
      <div className="gemdetail-page">
        <Navbar />
        <div className="gemdetail-notfound">
          <h2>Gem not found</h2>
          <button onClick={() => navigate(-1)}>Go Back</button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="gemdetail-page">
      <Navbar />

      <div className="gemdetail-content">
        <button className="gemdetail-back" onClick={() => navigate(-1)}>‹</button>

        <div className="gemdetail-main">
          {/* Image Gallery */}
          <div className="gemdetail-gallery">
            <div className="gallery-thumbnails">
              {allImages.map((img, i) => (
                <div
                  key={i}
                  className={`gallery-thumb ${i === selectedImg ? 'active' : ''}`}
                  onClick={() => setSelectedImg(i)}
                >
                  <img src={getImageUrl(img)} alt={`${gem.name} ${i + 1}`} />
                </div>
              ))}
              {allImages.length === 0 && (
                <div className="gallery-thumb active">
                  <div className="thumb-placeholder" />
                </div>
              )}
            </div>
            <div className="gallery-main-img">
              {allImages[selectedImg] ? (
                <img src={getImageUrl(allImages[selectedImg])} alt={gem.name} />
              ) : (
                <div className="main-img-placeholder">
                  <span>No Image</span>
                </div>
              )}
            </div>
          </div>

          {/* Info Panel */}
          <div className="gemdetail-info">
            <h1 className="gem-name">{gem.name}</h1>
            <p className="gem-origin">{gem.origin || 'Sri Lanka'}</p>
            <p className="gem-price">Rs.{gem.price?.toLocaleString()}</p>

            {/* Details Table */}
            <div className="gem-details">
              <h3>Details</h3>
              <table className="gem-details-table">
                <tbody>
                  {gem.weight && <tr><td>Weight:</td><td>{gem.weight}</td></tr>}
                  {gem.clarity && <tr><td>Clarity:</td><td>{gem.clarity}</td></tr>}
                  {gem.size && <tr><td>Size:</td><td>{gem.size}</td></tr>}
                  {gem.colour && <tr><td>Colour:</td><td>{gem.colour}</td></tr>}
                  {gem.shapeAndCut && <tr><td>Shape & Cut:</td><td>{gem.shapeAndCut}</td></tr>}
                  {gem.treatment && <tr><td>Treatment:</td><td>{gem.treatment}</td></tr>}
                  {gem.certificate && <tr><td>Certificate:</td><td>{gem.certificate}</td></tr>}
                  {gem.category && <tr><td>Category:</td><td>{gem.category}</td></tr>}
                  {gem.gemType && <tr><td>Type:</td><td>{gem.gemType}</td></tr>}
                </tbody>
              </table>
            </div>

            {/* Description */}
            {gem.description && (
              <div className="gem-description">
                <h3>Description</h3>
                <p>{gem.description}</p>
              </div>
            )}

            {/* Status badge */}
            <div className="gem-status-badge">
              <span className={`status-badge ${gem.status === 'Available' ? 'available' : 'sold'}`}>
                {gem.status}
              </span>
            </div>
          </div>
        </div>

        {/* You May Also Like */}
        {related.length > 0 && (
          <div className="related-section">
            <h2 className="related-title">YOU MAY ALSO LIKE</h2>
            <div className="related-grid">
              {related.map(g => <GemCard key={g._id} gem={g} />)}
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}